
import React, { useState, useEffect } from 'react';
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { AlertCircle } from 'lucide-react';

interface HostTroubleshootBannerProps {
  meetingLinkId: string;
  hostId: string;
  onToggleTroubleshoot: (enabled: boolean) => void;
}

export const HostTroubleshootBanner: React.FC<HostTroubleshootBannerProps> = ({
  meetingLinkId,
  hostId,
  onToggleTroubleshoot
}) => {
  const storageKey = `troubleshoot_${meetingLinkId}`;
  const [isTroubleshootMode, setIsTroubleshootMode] = useState(() => {
    return localStorage.getItem(storageKey) === 'true';
  });

  // Apply troubleshoot mode when first loaded
  useEffect(() => {
    console.log("HostTroubleshootBanner: Initial troubleshoot mode:", isTroubleshootMode);
    onToggleTroubleshoot(isTroubleshootMode);
  }, []);

  const handleToggle = (checked: boolean) => {
    console.log("Toggling troubleshoot mode:", checked);
    setIsTroubleshootMode(checked);
    localStorage.setItem(storageKey, String(checked));
    onToggleTroubleshoot(checked);
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-50 border-b border-amber-200 py-2 px-4">
      <div className="container max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-2 text-sm">
          <AlertCircle className="h-4 w-4 text-amber-600" />
          <span className="text-amber-800 font-medium">Host Preview Mode</span>
          <span className="text-amber-600 hidden sm:inline">— This banner is only visible to you as the meeting host</span>
        </div>
        
        <div className="flex items-center space-x-2">
          <Label htmlFor="troubleshoot-mode" className="text-sm text-amber-800">
            Troubleshoot Mode
          </Label>
          <Switch
            id="troubleshoot-mode"
            checked={isTroubleshootMode}
            onCheckedChange={handleToggle}
          />
        </div>
      </div>
    </div>
  );
};
